// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamento_AtualizarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/formas_pagamento/atualizar
 *
 * Updates an existing payment method (forma de pagamento).
 */
import { registerContract } from './validate'

export interface FormasPagamento_AtualizarInput {
forma_pagamento_id: number
forma_pagamento_nome: string
forma_pagamento_codigo?: string
forma_pagamento_possui_taxas?: number
forma_pagamento_aceita_parcelado?: number
forma_pagamento_taxa_mensal?: number
forma_pagamento_taxa_transacao?: number
forma_pagamento_taxa_transacao_tipo?: number
forma_pagamento_parcelas_max?: number
forma_pagamento_dias_para_receber?: number
}

registerContract('FormasPagamento_AtualizarInput', {
  forma_pagamento_id:                  { type: 'number',  required: true },
  forma_pagamento_nome:                { type: 'string',  required: true },
  forma_pagamento_codigo:              { type: 'string',  required: false },
  forma_pagamento_possui_taxas:        { type: 'number',  required: false },
  forma_pagamento_aceita_parcelado:    { type: 'number',  required: false },
  forma_pagamento_taxa_mensal:         { type: 'number',  required: false },
  forma_pagamento_taxa_transacao:      { type: 'number',  required: false },
  forma_pagamento_taxa_transacao_tipo: { type: 'number',  required: false },
  forma_pagamento_parcelas_max:        { type: 'number',  required: false },
  forma_pagamento_dias_para_receber:   { type: 'number',  required: false },
})
